
import { defineComponent, SetupContext, computed, toRefs, ref } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FavoritesFolderNameInputDialog",
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    showDialog: {
      type: Boolean,
      default: false
    },
    /** フォルダ名の初期値 */
    folderName: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      inputFolderName: this.folderName
    };
  },
  methods: {
    appendClicked() {
      this.$emit("append-click", this.inputFolderName);
    }
  },
  setup(props, context: SetupContext) {
    const { folderName } = toRefs(props);

    /** テキスト */
    const titleText = "フォルダ名を設定する";
    const inputTitleText = "フォルダ名（15文字以内）";
    const placeHolderText = "フォルダ名を入力";
    const buttonText = computed(() => {
      if (folderName.value.length > 0) {
        return "変更";
      }
      return "追加";
    });

    const inputText = ref("");
    NativeClient.sendDebugLog("FavoritesFolderNameInputDialog data() fileName = " + folderName.value);

    const beforeFileName = computed(() => {
      return folderName.value;
    });

    // 入力文字
    const inputFolderName = computed({
      get: () => inputText.value,
      set: value => (inputText.value = value)
    });

    /** 閉じるボタン */
    const closeClicked = () => {
      context.emit("close-click");
    };

    return {
      titleText,
      inputTitleText,
      placeHolderText,
      beforeFileName,
      buttonText,
      closeClicked
    };
  }
});
